module.exports = __webpack_public_path__ + "static/media/company4.5b180c5b.png";